import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_BASE
axios.defaults.timeout = 100000

axios.interceptors.request.use((config) => {
    const jwt = window.localStorage.getItem('jwt');
    if (jwt && config.headers.Authorization !== '') {
        config.headers.Authorization = `Bearer ${jwt}`;
    }
    return config;
});

function isAuthExpiredError(error) {
    const status = error.response && error.response.status;
    const data = error.response && error.response.data;
    if (!data) {
        return status === 401;
    }
    const code = String(data.code || '');
    const nestedStatus = Number(
        data.statusCode ||
        (data.data && data.data.status) ||
        0
    );

    // JWT Auth: expired/invalid token → jwt_auth_* + often data.status 403
    if (code.startsWith('jwt_auth_') && code !== 'jwt_auth_no_auth_header') {
        return true;
    }

    if (status === 401 || nestedStatus === 401) {
        return true;
    }

    return false;
}

let redirectingToLogin = false;

function forceLoginRedirect() {
    if (redirectingToLogin) return;
    if (window.location.pathname === '/login') return;

    redirectingToLogin = true;
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    window.location.assign('/login');
}

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isAuthExpiredError(error)) {
            forceLoginRedirect();
        }
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data);
        }
        return Promise.reject(error.message);
    }
);

export default axios;
